/**
 * Forms open in the chat (14 Oct, Rusty's screenshot): while a request or
 * incident form is open and unsent, the full composer under it confused
 * people ("fill in the form, or type in the box?") and the form scrolled
 * behind it. So the composer gives way to a slim bar until the form is sent
 * or cancelled, or the person asks to type instead. Pure, so
 * `tests/inline-forms.test.mjs` runs it without React.
 */

/** What sits at the bottom of the chat. */
export type ComposerMode = "composer" | "formBar";

/** The open forms, by key: added while one is open and unsent, removed after. */
export function withForm(open: readonly string[], key: string, isOpen: boolean): string[] {
  const has = open.includes(key);
  if (isOpen === has) {
    return [...open];
  }
  return isOpen ? [...open, key] : open.filter((item) => item !== key);
}

/**
 * The composer, unless a form is open and the person has not asked to type
 * instead. "Ask something instead" is for the forms open when it was pressed:
 * a form opened later brings the bar back.
 */
export function composerMode(
  open: readonly string[],
  askedInsteadFor: readonly string[],
): ComposerMode {
  return open.some((key) => !askedInsteadFor.includes(key)) ? "formBar" : "composer";
}
